// The delivery states an empty-pickup confirmation may transition from — «Confirmar recogida
// vacía» records that the «buzón» was found empty. Matched case-insensitively; fail closed on
// any unrecognized state. Distinct from isConfirmable/isRestorable: includes `collected`
// (opening the box auto-registered a pickup that found nothing) and excludes `non_collected`
// (already there) and `cancelled`.
const NON_COLLECTABLE_STATES = new Set(['stored', 'collected', 'blocked', 'expired', 'rejected']);

export function isNonCollectable(status: string): boolean {
  return NON_COLLECTABLE_STATES.has(status.toLowerCase());
}
